export default {"src":"/_next/static/media/hero_f_orange.de5bcdf1.svg","height":470,"width":325,"blurWidth":0,"blurHeight":0};